import Service, { service } from '@ember/service'
import type AuthToken from '@blakeelearning/auth/services/auth-token'
import type { Log } from '@blakeelearning/log'
import config from 'teacher-ui-client/config/environment'
import { join } from 'teacher-ui-client/utils/uri'

export default class WritingLegendsCatalogueService extends Service {
  @service authToken!: AuthToken

  @service log!: Log

  get headers() {
    return {
      Authorization: `Bearer ${this.authToken.token}`,
      Accept: 'application/json',
      'Content-Type': 'application/json',
    }
  }

  buildUrlEWI(): string {
    return join(config.writingLegendsApiUrl, 'v1', 'views', 'EWI', 'activity_catalogue').href
  }

  buildUrlLongWrites(): string {
    return join(config.writingLegendsApiUrl, 'v1', 'retui', 'longwritescatalogue').href
  }

  buildActivityUrl(activityId: string): string {
    return join(config.writingLegendsApiUrl, 'v1', 'retuiewi', 'activities', activityId).href
  }

  async fetchData<R>(url: string): Promise<R | undefined> {
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: this.headers,
      })

      if (response.ok) {
        return (await response.json()) as R
      } else {
        // Some unknown error. Log it.
        this.log.error(`Failed to fetch long-writes catalogue; Reason: (${response.status})`, url)
      }
    } catch (e: any) {
      if (e instanceof DOMException && e.name === 'AbortError') {
        // Fetch aborted by user action, eg closed tab, stop button, network outage. Do nothing.
      } else {
        this.log.error(`Failed to fetch long-writes catalogue; Reason: (error thrown)`, e, url)
      }
    }
    // we've done our best by reporting the error(s),
    // the caller should handle an undefined result.
    return undefined
  }
}
declare module '@ember/service' {
  interface Registry {
    longWrites: WritingLegendsCatalogueService
  }
}
